import axiosInstance from "./axiosInstance";

/** Compatibility for endpoints that page correctly but ignore search or its count. */
export function createClientSearchPage(matches) {
  return async (url, config) => {
    const requested = new URL(url);
    const term = requested.searchParams.get("search")?.trim();
    if (!term) return axiosInstance(url, config);
    const page = Math.max(1, Number(requested.searchParams.get("Page")) || 1);
    const limit = Math.max(1, Number(requested.searchParams.get("Limit")) || 50);
    const batch = new URL(requested);
    batch.searchParams.delete("search");
    batch.searchParams.set("Limit", "100");
    const rows = new Map();
    let response, current = 1, last = 1;
    do {
      batch.searchParams.set("Page", current);
      response = await axiosInstance(batch.toString(), config);
      if (!Array.isArray(response.data?.data)) throw new Error("پاسخ فهرست معتبر نیست.");
      const previousSize = rows.size;
      response.data.data.forEach((row) => rows.set(row.id ?? row.Id, row));
      last = Number(response.data.meta?.total_pages || (response.data.data.length === 100 ? current + 1 : current));
      if (current < last && rows.size === previousSize) throw new Error("پاسخ صفحه‌بندی فهرست معتبر نیست.");
      current++;
    } while (current <= last);
    const filtered = [...rows.values()].filter((row) => matches(row, term));
    return { ...response, data: { ...response.data,
      data: filtered.slice((page - 1) * limit, page * limit),
      meta: { ...response.data.meta, total: filtered.length, total_pages: Math.max(1, Math.ceil(filtered.length / limit)) },
    } };
  };
}

export function includesSearch(values, term) {
  return values.some((value) => value != null && String(value).toLocaleLowerCase().includes(term.toLocaleLowerCase()));
}
